var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.6272,
    r: 17.5,
    fill: "#35475D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2448 17.1512C20.3134 17.1512 21.9904 15.1143 21.9904 12.6016C21.9904 10.0889 21.4398 8.052 18.2448 8.052C15.0497 8.052 14.499 10.0889 14.499 12.6016C14.499 15.1143 16.1761 17.1512 18.2448 17.1512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1697 24.098C11.169 23.9448 11.1684 24.0549 11.1697 24.098V24.098Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3193 24.2173C25.3213 24.1753 25.32 23.9263 25.3193 24.2173V24.2173Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3113 23.9139C25.2419 19.5367 24.6703 18.2895 20.2958 17.5C20.2958 17.5 19.68 18.2847 18.2447 18.2847C16.8095 18.2847 16.1936 17.5 16.1936 17.5C11.8668 18.2809 11.2604 19.5096 11.1807 23.7717C11.1741 24.1197 11.1711 24.138 11.1699 24.0976C11.1702 24.1733 11.1705 24.3133 11.1705 24.5574C11.1705 24.5574 12.212 26.657 18.2447 26.657C24.2774 26.657 25.319 24.5574 25.319 24.5574C25.319 24.4006 25.3191 24.2915 25.3192 24.2173C25.3181 24.2423 25.3157 24.1938 25.3113 23.9139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6052,
    height: 18.6052,
    fill: "white",
    transform: "translate(8.94141 8.052)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile_circle.54992f1a3f2e91c1d55fe35a69aa58f1.svg";
export { ForwardRef as ReactComponent };